import { Button, Card, Typography } from "@arco-design/web-react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { guestIntakeConvertPath } from "../../constants/guestIntake";
import { useEventIntakeEnabled } from "../../hooks/useEventIntakeEnabled";
import { RootState } from "../../store/store";

import "./GuestHomeConversionBanner.css";

function shouldShowGuestHomeBanner(
  user: { id?: number; isGuest?: boolean; isAdmin?: boolean; isMentor?: boolean } | null,
): boolean {
  return Boolean(user?.id && user.isGuest && !user.isAdmin && !user.isMentor);
}

export function GuestHomeConversionBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const eventIntakeEnabled = useEventIntakeEnabled();
  const user = useSelector((state: RootState) => state.user.user);
  const brandName = useSelector((state: RootState) => state.config.brandName);
  const displayBrand = brandName.trim() || "WERULE";
  const expired = Boolean(user?.guestExpired);

  if (!eventIntakeEnabled || !shouldShowGuestHomeBanner(user)) {
    return null;
  }

  return (
    <Card className="card-with-icon-hover own-card guest-home-conversion-banner">
      <Typography.Title heading={4} className="guest-home-conversion-banner__title">
        {expired
          ? t("guest_conversion.title_expired", { brandName: displayBrand })
          : t("guest_conversion.home_title")}
      </Typography.Title>
      <Typography.Text className="guest-home-conversion-banner__body">
        {expired ? t("guest_conversion.body_expired") : t("guest_conversion.home_body")}
      </Typography.Text>
      <div className="guest-home-conversion-banner__cta-wrap">
        <Button
          htmlType="button"
          type="default"
          className="guest-home-conversion-banner__cta"
          size="default"
          shape="round"
          onClick={() => navigate(guestIntakeConvertPath())}
        >
          {t("guest_conversion.home_choose_role_button")}
        </Button>
      </div>
    </Card>
  );
}
